import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "expanded", "icon", "selected", "tabIndex", "text"];

/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { colors } from '@flowio/react-theme';
import { rgba } from 'polished';
import React from 'react';
import NavText from './NavText';
import NavIcon from './NavIcon';
import NavIndicator from './NavIndicator';

var NavHeader = function NavHeader(_ref) {
  var children = _ref.children,
      _ref$expanded = _ref.expanded,
      expanded = _ref$expanded === void 0 ? true : _ref$expanded,
      icon = _ref.icon,
      _ref$selected = _ref.selected,
      selected = _ref$selected === void 0 ? false : _ref$selected,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex,
      text = _ref.text,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  var ariaProps = {
    role: 'tab',
    'aria-selected': expanded,
    'aria-expanded': expanded
  };
  var rootStyles = /*#__PURE__*/css({
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    minHeight: '32px',
    margin: '0',
    padding: '0 8px',
    borderRadius: '4px',
    boxSizing: 'border-box',
    cursor: 'pointer',
    userSelect: 'none',
    '&:focus': {
      outline: '0',
      boxShadow: "0 0 0 2px ".concat(rgba(colors.FLOW_BLUE_300, 0.5), ", 0 0 6px 0 ").concat(rgba(colors.FLOW_BLUE_400, 0.5), ", inset 0 0 4px 0 ").concat(rgba(colors.WHITE, 0.75))
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:rootStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
  return jsx("h4", _extends({}, ariaProps, unhandledProps, {
    css: rootStyles,
    tabIndex: tabIndex
  }), children != null ? children : jsx(React.Fragment, null, jsx(NavIcon, {
    active: selected,
    iconName: icon
  }), jsx(NavText, {
    active: selected
  }, text), jsx(NavIndicator, {
    active: selected,
    expanded: expanded
  })));
};

export default NavHeader;